function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.04 8.111a.634.634 0 01.507 1.015l-3.044 4.058H5.04a.634.634 0 110 1.268H1.235a.634.634 0 01-.507-1.014L3.77 9.379H1.235a.634.634 0 110-1.268zm6.34-2.536c.35 0 .635.283.635.634v6.078l1.454-1.454a.634.634 0 01.898.897l-2.537 2.536a.634.634 0 01-.898 0L8.396 11.73a.634.634 0 01.897-.897l1.454 1.454V6.21c0-.35.283-.634.634-.634zM8.602.55a.634.634 0 01.692.137l2.536 2.537a.634.634 0 01-.897.897L9.478 2.667V8.11a.634.634 0 11-1.268 0V2.667L6.755 4.12a.634.634 0 01-.897-.897L8.395.687C8.454.628 8.524.582 8.6.55zM3.137.5c.265 0 .502.165.594.413l1.903 5.072a.634.634 0 11-1.189.447l-.32-.857H2.15l-.321.857a.634.634 0 11-1.188-.447L2.543.913A.634.634 0 013.137.5zm0 2.442l-.512 1.364H3.65l-.512-1.364z",
  fill: "#54585D"
}))));